export enum ECatalogProductOfferType {
  CART = 'cart',
  CATALOG = 'catalog',
}
